import React, { useEffect, useState, useContext } from "react";
import HLSPlayer from "./HLSPlayer";
import UserContext from "./UserContext";
import "./SongMode.css";
import { Link } from "react-router-dom";
import SongSorter from "./SongSorter";
import ArtistSearch from "./ArtistSearch";
import { useNavigate } from "react-router-dom";
import ConcertCalendar from "./ConcertCalendar";
import MusicWireTicker from "./MusicWireTicker";
import MusicNewsPanel from "./MusicNewsPanel";
import funnelImg from "./funnel3.png";

const API_URL = "/api/songs";

const SongMode = () => {
  const [songs, setSongs] = useState([]);
  const [currentSong, setCurrentSong] = useState(null);
  const { user } = useContext(UserContext); 
  const [sortMode, setSortMode] = useState("recent");
  const [artistSearch, setArtistSearch] = useState("");	
  const [expandedSongId, setExpandedSongId] = useState(null);
  const [commentsBySong, setCommentsBySong] = useState({});
  const [commentDrafts, setCommentDrafts] = useState({});
  const [continuousPlay, setContinuousPlay] = useState(false);
  const navigate = useNavigate();	
  const [showsPanelOpen, setShowsPanelOpen] = useState(false);
  const [selectedGenre, setSelectedGenre] = useState("ALL");
  const [gigFormOpen, setGigFormOpen] = useState(false);
  const [autoStartPlay, setAutoStartPlay] = useState(false);
  const [aboutPanelOpen, setAboutPanelOpen] = useState(false);

  useEffect(() => {
    fetch(API_URL)
      .then(response => response.json())
      .then(data => {
        setSongs(data);
        if (data.length > 0) {
          setCurrentSong(data[0]);
        }
      })
      .catch(error => console.error("Error fetching songs:", error));
  }, []);

useEffect(() => {
  const handleOpenAbout = () => setAboutPanelOpen(true);
  window.addEventListener('openAboutDrawer', handleOpenAbout);
  return () => window.removeEventListener('openAboutDrawer', handleOpenAbout);
}, []);



 useEffect(() => {
  const handleOpenShows = () => setShowsPanelOpen(true);
  
  window.addEventListener('openShowsDrawer', handleOpenShows);
  
  return () => window.removeEventListener('openShowsDrawer', handleOpenShows);
}, []);

  const handleSongEnd = () => {
  if (!continuousPlay) return;
  if (visibleSongs.length === 0 || !currentSong) return;

  const currentIndex = visibleSongs.findIndex(song => song.id === currentSong.id);
  if (currentIndex === -1) return;

  const nextIndex = (currentIndex + 1) % visibleSongs.length;
  setCurrentSong(visibleSongs[nextIndex]);
};

const handleGigSubmit = async (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const data = Object.fromEntries(formData);

  // Add username if logged in
  if (user) {
    data.username = user.username;
  }

  try {
    const response = await fetch('/api/submit-gig/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    if (response.ok) {
      alert("Gig submitted! We'll get it up there ASAP.");
      setGigFormOpen(false);
      e.target.reset();
    } else {
      alert("Something went wrong. Try again!");
    }
  } catch (error) {
    alert("Something went wrong. Try again!");
  }
};

const handlePlayClick = (song, e) => {
  e.stopPropagation();
  handleSongClick(song);
  setAutoStartPlay(true);
  setTimeout(() => setAutoStartPlay(false), 500);
};


  // ✅ NEW: Handle like button click
const handleLike = async (songId, e) => {
  e.stopPropagation();

  if (!user) {
    alert("Please log in to like songs");
    return;
  }

  try {
    const response = await fetch(`/api/songs/${songId}/like/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    setSongs(prevSongs =>
      prevSongs.map(song =>
        song.id === songId
          ? { ...song, like_count: data.like_count, user_has_liked: data.liked }
          : song
      )
    );

    setCurrentSong(prevCurrentSong =>
      prevCurrentSong && prevCurrentSong.id === songId
        ? {
            ...prevCurrentSong,
            like_count: data.like_count,
            user_has_liked: data.liked,
          }
        : prevCurrentSong
    );
  } catch (error) {
    console.error("Error liking song:", error);
  }
};

      
const isMobile = window.innerWidth <= 768;

 const handlePlayerLike = (songId, newLikeCount, newLikedStatus) => {
  setSongs(prevSongs =>
    prevSongs.map(song =>
      song.id === songId
        ? { ...song, like_count: newLikeCount, user_has_liked: newLikedStatus }
        : song
    )
  );

  setCurrentSong(prevCurrentSong =>
    prevCurrentSong && prevCurrentSong.id === songId
      ? {
          ...prevCurrentSong,
          like_count: newLikeCount,
          user_has_liked: newLikedStatus,
        }
      : prevCurrentSong
  );
};

const handleSongClick = async (song) => {
  // 1. switch the player
  setCurrentSong(song);

  // 2. send click to backend
  try {
    const res = await fetch(`/api/songs/${song.id}/click/`, {
      method: "POST",
    });

    const data = await res.json();

    // 3. update UI state
    setSongs(prevSongs =>
      prevSongs.map(s =>
        s.id === song.id
          ? { ...s, click_count: data.click_count }
          : s
      )
    );

  } catch (err) {
    console.error("click error:", err);
  }
};
	
const handlePlayerPlay = (songId, newPlayCount) => {
  setSongs(prevSongs =>
    prevSongs.map(song =>
      song.id === songId
        ? { ...song, partial_plays: newPlayCount }
        : song
    )
  );

  setCurrentSong(prevCurrentSong =>
    prevCurrentSong && prevCurrentSong.id === songId
      ? { ...prevCurrentSong, partial_plays: newPlayCount }
      : prevCurrentSong
  );
};

const genreFilters = [
  "ALL",
  "BLUES",
  "JAZZ",
  "PUNK",
  "METAL",
  "HARDCORE",
  "PROGRESSIVE",
  "PSYCHEDELIC",
  "HIP-HOP",
  "R&B",
  "ELECTRONIC",
  "REGGAE",
  "LATIN",
  "FOLK",
  "FUNK",
  "NOISE",
  "GOTH",
  "OTHER"
];

const visibleSongs = [...songs]
  .filter(song =>
    selectedGenre === "ALL" ||
    song.genre_names.includes(selectedGenre)
  )
  .filter(song =>
    song.artist_name.toLowerCase().includes(artistSearch.toLowerCase())
  )
  .sort((a, b) => {
    if (sortMode === "likes") {
      return (b.like_count || 0) - (a.like_count || 0);
    }

    if (sortMode === "clicks") {
      return (b.click_count || 0) - (a.click_count || 0);
    }

    if (sortMode === "plays") {
      return (b.partial_plays || 0) - (a.partial_plays || 0);
    }

    return new Date(b.created_at) - new Date(a.created_at);
  });


const handleAddToPlaylist = async (songId, e) => {
  e.stopPropagation();

  if (!user) {
    alert("Please log in to add songs to your playlist");
    return;
  }

  try {
    const response = await fetch(`/api/songs/${songId}/add-to-playlist/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to add song to playlist");
    }

    alert("Added to playlist");
  } catch (error) {
    console.error("Error adding to playlist:", error);
    alert("Could not add song to playlist");
  }
};

const toggleComments = async (songId, e) => {
  e.stopPropagation();

  if (expandedSongId === songId) {
    setExpandedSongId(null);
    return;
  }

  setExpandedSongId(songId);

  if (!commentsBySong[songId]) {
    try {
      const response = await fetch(`/api/songs/${songId}/comments/`);
      const data = await response.json();

      setCommentsBySong(prev => ({
        ...prev,
        [songId]: data,
      }));
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  }
};

const handleCommentDraftChange = (songId, value) => {
  if (value.length > 280) return;

  setCommentDrafts(prev => ({
    ...prev,
    [songId]: value,
  }));
};

const handleSubmitComment = async (songId, e) => {
  e.preventDefault();
  e.stopPropagation();

  if (!user) {
    alert("Please log in to comment");
    return;
  }

  const text = (commentDrafts[songId] || "").trim();

  if (!text) return;

  try {
    const response = await fetch(`/api/songs/${songId}/comments/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ text }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || data.detail || "Could not post comment");
    }

    setCommentsBySong(prev => ({
      ...prev,
      [songId]: [data, ...(prev[songId] || [])],
    }));

    setCommentDrafts(prev => ({
      ...prev,
      [songId]: "",
    }));
  } catch (error) {
    console.error("Error posting comment:", error);
    alert(error.message);
  }
};




return(
	<div className="song-mode-page">
	{/* MOBILE PLAYER - outside the grid */}
	<div className="mobile-player-wrapper">
  {currentSong && (
  <HLSPlayer
    song={currentSong}
    isMobile={true}
    onSongEnd={handleSongEnd}
    onNext={handleSongEnd}
    onLikeUpdate={handlePlayerLike}
    onPlayUpdate={handlePlayerPlay}
    autoPlay={autoStartPlay}
    playOnLoad={continuousPlay}
  />
)}
</div>

{/* DESKTOP CONTROLS GRID - hidden on mobile */}
	<div className="song-control-grid">
  {/* LEFT: GENRE FILTER + SORTER */}
  <div className="song-control-panel song-filter-stack">
    <div className="genre-filter-panel">
      {genreFilters.map(genre => (
        <button
          key={genre}
          type="button"
          className={`genre-filter-button ${selectedGenre === genre ? "active" : ""}`}
          onClick={() => setSelectedGenre(genre)}
        >
          {genre === "PROGRESSIVE"
            ? "PROG"
            : genre === "PSYCHEDELIC"
            ? "PSYCH"
            : genre}
        </button>
      ))}
    </div>

    <div className="filter-pipe"></div>
    <SongSorter
  sortMode={sortMode}
  setSortMode={setSortMode}
/>

	<div className="song-output-funnel">
  <img src={funnelImg} alt="funnel" />
</div>
</div>
  {/* CENTER: PLAYER */}
	<div> 
  {currentSong ? (
    <HLSPlayer
      song={currentSong}
      isMobile={isMobile}
      onSongEnd={handleSongEnd}
      onNext={handleSongEnd}
      onLikeUpdate={handlePlayerLike}
      onPlayUpdate={handlePlayerPlay}
      autoPlay={autoStartPlay} 
      playOnLoad={continuousPlay}
    />
  ) : (
    <p>Loading...</p>
  )}
     
<div className="autoplay-toggle">
  <span className="autoplay-label">
    AUTOPLAY
  </span>

  <button
    type="button"
    className={`autoplay-switch ${continuousPlay ? "on" : "off"}`}
    onClick={() => setContinuousPlay(prev => !prev)}
  >
    <span className={!continuousPlay ? "active" : ""}>
      OFF
    </span>

    <span className={continuousPlay ? "active" : ""}>
      ON
    </span>
  </button>
</div>
	
	
</div> 
  {/* RIGHT: SEARCH */}
<div
  className="song-control-panel"
  style={{
    maxWidth: "420px",
    justifySelf: "end",
  }}
>
  <ArtistSearch
    artistSearch={artistSearch}
    setArtistSearch={setArtistSearch}
  />
</div>
</div>




	<ul className="song-list">
  {visibleSongs.map((song, index) => (
    <li key={index}>
       <div
  onClick={() => handleSongClick(song)}
  className="song-row"
  style={{ cursor: "pointer" }}
>
  {/* PLAY BUTTON - far left */}
  <button
    type="button"
    className="song-play-action"
    onClick={(e) => handlePlayClick(song, e)}
  >
    ▶
  </button>

  {/* TITLE BLOCK - middle */}
  <div className="song-title-block">
    <span className="song-title">
      {song.title}
    </span>
    <Link
      to={`/artist/${song.artist_name}`}
      className="song-artist-link"
      onClick={(e) => e.stopPropagation()}
    >
      by {song.artist_name}
    </Link>
  </div>

  {/* STATS - far right */}
  <div className="song-stats">
    <button
      type="button"
      className="song-strip-action playlist-action"
      title="Add to playlist"
      onClick={(e) => handleAddToPlaylist(song.id, e)}
    >
      +LIST
    </button>
    <div className="song-like-wrapper">
      <span
        className="song-like-action"
        onClick={(e) => handleLike(song.id, e)}
      >
        {song.user_has_liked ? "LIKED" : "LIKE"}
      </span>
      <span className="song-like-count">
        {song.like_count || 0}
      </span>
    </div>
    <span className="song-stat">
      CLICKS <strong>{song.click_count || 0}</strong>
    </span>
    <span className="song-stat">
      PLAYS <strong>{song.partial_plays || 0}</strong>
    </span>
    <button
      type="button"
      className="song-disclosure-action"
      title="Show comments"
      onClick={(e) => toggleComments(song.id, e)}
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>

</div>
















      {expandedSongId === song.id && (
  <div className="song-comments-panel" onClick={(e) => e.stopPropagation()}>
    <div className="song-comments-list">
      {(commentsBySong[song.id] || []).slice(0, 3).map(comment => (
        <div className="song-comment" key={comment.id}>
          <div className="song-comment-meta">
            {comment.username} · {comment.timestamp}
          </div>
          <div className="song-comment-text">
            {comment.text}
          </div>
        </div>
      ))}

      {commentsBySong[song.id] && commentsBySong[song.id].length === 0 && (
        <div className="song-comment-empty">
          No comments yet.
        </div>
      )}
    </div>

    <form
      className="song-comment-form"
      onSubmit={(e) => handleSubmitComment(song.id, e)}
    >
      <input
        type="text"
        maxLength="280"
        placeholder={user ? "Add a comment..." : "Log in to comment"}
        value={commentDrafts[song.id] || ""}
        onChange={(e) => handleCommentDraftChange(song.id, e.target.value)}
        disabled={!user}
      />

      <button type="submit" disabled={!user}>
        POST
      </button>
    </form>
  </div>
)}



    </li>
  ))}
</ul>
	<MusicNewsPanel />
<div className="signal-footer">
  <div className="signal-skyline">
    NYC▁▂▃▅▇▆▃▂▁
  </div>

  <div className="signal-footer-text">
    <span>SUPPORT LOCAL. STREAM NYC. KEEP THE SCENE ALIVE.</span>
    <span className="signal-divider">|</span>
    <span className="signal-brand">© SIGNALBLEED.NYC 2026</span>
    <span className="signal-divider">|</span>
    <span className="signal-built">BUILT IN NYC ♡</span>
  </div>
</div>


{showsPanelOpen && (
  <div
    className="shows-overlay"
    onClick={() => setShowsPanelOpen(false)}
  >
    <div
      className="shows-drawer"
      onClick={(e) => e.stopPropagation()}
    >
	{/* TOP BAR */}
      <div className="drawer-top-bar">
        <button
          type="button"
          className="submit-gig-btn"
          onClick={() => setGigFormOpen(prev => !prev)}
        >
          + SUBMIT GIG
        </button>

        <button
          type="button"
          className="shows-drawer-close"
          onClick={() => setShowsPanelOpen(false)}
        >
          ×
        </button>
      </div>

      {/* GIG FORM - expands when clicked */}
      {gigFormOpen && (
        <div className="gig-form-panel">
          {user ? (
            <>
              <p className="gig-form-intro">
                You're logged in! We'll use <strong>{user.username}</strong> as your artist name. If that's not right, mention it in Extra Info. We already have your email too - drop a different one in Extra Info if you prefer.
              </p>
              <form className="gig-form" onSubmit={handleGigSubmit}>
                <input className="gig-input" type="text" placeholder="Venue name" name="venue" required />
                <input className="gig-input" type="date" name="date" required />
                <input className="gig-input" type="time" name="time" />
                <input className="gig-input" type="text" placeholder="All artists on the bill (include yourself)" name="artists" required />
                <input className="gig-input" type="url" placeholder="Ticket link or flyer URL (optional)" name="ticket_url" />
                <input className="gig-input" type="tel" placeholder="Phone number (optional)" name="phone" />
                <textarea className="gig-input gig-textarea" placeholder="Extra info - anything else we should know!" name="extra" rows="3" />
                <button type="submit" className="gig-submit-btn">SUBMIT GIG</button>
              </form>
            </>
          ) : (
            <>
              <p className="gig-form-intro">
                Anyone can submit a gig. If you're submitting here, you're probably flying under the radar - and that's exactly who we're here for. We'll add your show AND bump it to the top.
                <br /><br />
                <span style={{ color: "#00d4ff" }}>
                  Want a free band page too? <a href="/register" style={{ color: "#ff2b63" }}>Register here</a> - totally optional.
                </span>
              </p>
              <form className="gig-form" onSubmit={handleGigSubmit}>
                <input className="gig-input" type="email" placeholder="Your email" name="email" required />
                <input className="gig-input" type="text" placeholder="Your band/artist name" name="bandname" required />
                <input className="gig-input" type="text" placeholder="All artists on the bill (include yourself)" name="artists" required />
                <input className="gig-input" type="text" placeholder="Venue name" name="venue" required />
                <input className="gig-input" type="date" name="date" required />
                <input className="gig-input" type="time" name="time" />
                <input className="gig-input" type="url" placeholder="Ticket link or flyer URL (optional)" name="ticket_url" />
                <input className="gig-input" type="tel" placeholder="Phone number (optional)" name="phone" />
                <textarea className="gig-input gig-textarea" placeholder="Extra info - anything else we should know!" name="extra" rows="3" />
                <button type="submit" className="gig-submit-btn">SUBMIT GIG</button>
              </form>
            </>
          )}
        </div>
      )}

      <ConcertCalendar />
    </div>
  </div>
)}

{aboutPanelOpen && (
  <div
    className="about-overlay"
    onClick={() => setAboutPanelOpen(false)}
  >
    <div
      className="about-drawer"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="about-drawer-close"
        onClick={() => setAboutPanelOpen(false)}
      >
        ×
      </button>





<div className="about-content">
  <h2 className="about-title">SIGNALBLEED.NYC</h2>
  <p className="about-tagline">Built for New York City's underground music scene.</p>

  <p className="about-body">
    We help listeners discover great independent artists, find local shows, and connect directly with the musicians and venues that keep the city's music culture alive.
  </p>

  <div className="about-section">
    <h3>FOR ARTISTS</h3>
    <ul>
      <li>Register for a free artist page</li>
      <li>Upload your songs</li>
      <li>Submit your gigs — any venue, any borough, any size</li>
      <li>Set up your tip jar — Cash App, Venmo, Bandcamp, PayPal, whatever you use</li>
    </ul>
  </div>

  <div className="about-section">
    <h3>FOR LISTENERS</h3>
    <ul>
      <li>Browse music by genre</li>
      <li>Build and share playlists</li>
      <li>Discover shows via the concert calendar</li>
      <li>Support artists directly — no middleman, no platform fees</li>
    </ul>
  </div>

  <div className="about-section">
    <h3>SHOWS</h3>
    <ul>
      <li>Got a gig? Hit the Submit Gig button on the concert calendar — we'll get it posted ASAP</li>
    </ul>
  </div>

  <div className="about-section">
    <h3>FOR EVERYBODY</h3>
    <p className="about-body">
      Your SignalBleed account is yours to shape. Upload songs or don't. 
      Share your playlist or keep it private. You don't have to decide 
      what kind of music person you are today — you can be a listener, 
      an artist, or both. Your profile grows with you.
    </p>
  </div>

  <div className="about-contact">
    <span>CONTACT: </span>
    <a href="mailto:dan@signalbleed.nyc">dan@signalbleed.nyc</a>
  </div>
</div>






    </div>
  </div>
)}

<button
      type="button"
      className="shows-rail"
      onClick={() => setShowsPanelOpen(true)}
    >
      <span>TONIGHT</span>
      <span>IN NYC</span>
      <strong>SHOWS →</strong>
    </button>              

{/* MOBILE BOTTOM CONTROLS */}
<div className="mobile-bottom-controls">
  
  {/* GENRE PANEL */}
  <div className="mobile-panel">
    <div className="mobile-panel-label">GENRE</div>
    <div className="mobile-genre-active">{selectedGenre}</div>
    <div className="mobile-genre-list">
      {genreFilters.slice(0, 4).map(g => (
        <button key={g}
          className={`mobile-genre-btn ${selectedGenre === g ? "active" : ""}`}
          onClick={() => setSelectedGenre(g)}>
          {g === "PROGRESSIVE" ? "PROG" : g === "PSYCHEDELIC" ? "PSYCH" : g}
        </button>
      ))}
      <button className="mobile-genre-btn" onClick={() => setSelectedGenre("ALL")}>MORE</button>
    </div>
  </div>

  {/* SORT PANEL */}
  <div className="mobile-panel">
    <div className="mobile-panel-label">SORT BY</div>
    <button className={`mobile-sort-btn ${sortMode === "recent" ? "active" : ""}`}
      onClick={() => setSortMode("recent")}>RECENT</button>
    <div className="mobile-sort-row">
      <button className={`mobile-sort-btn small ${sortMode === "likes" ? "active" : ""}`}
        onClick={() => setSortMode("likes")}>LIKES</button>
      <button className={`mobile-sort-btn small ${sortMode === "plays" ? "active" : ""}`}
        onClick={() => setSortMode("plays")}>PLAYS</button>
    </div>
  </div>

  {/* SEARCH + AUTOPLAY PANEL */}
  <div className="mobile-panel">
    <div className="mobile-panel-label">SEARCH</div>
    <input
      type="text"
      className="mobile-search-input"
      placeholder="artist..."
      value={artistSearch}
      onChange={(e) => setArtistSearch(e.target.value)}
    />
    <button
      type="button"
      className="autoplay-switch"
      onClick={() => setContinuousPlay(prev => !prev)}
    >
      <span className={!continuousPlay ? "active" : ""}>OFF</span>
      <span className={continuousPlay ? "active" : ""}>ON</span>
    </button>
  </div>

</div>


    </div>
  );

};

export default SongMode;
